/** recursively call function on object and children  */
function RgDeepCallback(obj, callback) {
    callback(obj);
    for (const c of obj.children) {
        RgDeepCallback(c, callback);
    }
}

export { RgDeepCallback };
//# sourceMappingURL=rg-deep-callback.js.map
